import { Box, Typography } from "@mui/material";
import PleaseSelectBrandAndFranchiseImage from '../assets/img/error_images/please_select_brand_and_franchise.png'

export default function PleaseSelectBrandAndFranchise(props) {
    const { message = "Please select a brand and franchise" } = props
    return <Box sx={{ margin: "auto", display: "flex", flexDirection: "column", alignItems: "center", padding: "30px" }} >
        <img style={{ width: "15em", height: "15em" }} src={PleaseSelectBrandAndFranchiseImage} />
        <Typography marginTop="1em" variant="h6">{message}</Typography>
    </Box>
}